export default __webpack_public_path__ + "static/kb_2_7-4eb400cae688deb4dc074f6ab62121bc.jpg";